/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:01/05/2022
 @Time:14:16
 **/

import ImageFile from "./ImageFile";


export default class CachetFile extends ImageFile {
    /**
     * @type {Societe}
     */
    #_societe;




    static createFromJson(cachetJsonFile,file)
    {
        file=new CachetFile();
        super.createFromJson(cachetJsonFile,file);
        return file;
    }


    getFileURLFileType() {
        return "SOCIETE_CACHET";
    }
}